import { Swiper, Pagination } from 'swiper';
import { $ } from '../utils/jquery.js';

function ourGalleryBottomSlider() {
  const sliderSelector = ".js-our-gallery-slider";
  const scrollbarSelector = ".js-our-gallery-scrollbar";

  if ($(sliderSelector).length === 0) {
    return;
  }

  const slider = new Swiper(sliderSelector, {
    slidesPerView: "auto",
    centeredSlides: false,
    modules: [Pagination],
    spaceBetween: 24,
    mousewheel: {
      forceToAxis: true,
    },
    pagination: {
      el: '.js-our-gallery-scrollbar',
      type: 'progressbar'
    },
    breakpoints: {
      1024: {
        spaceBetween: 36,
      },
    },
  });
}

function stepsLoopSlider() {
  const sliderSelector = ".js-steps-loop-slider";
  const scrollbarSelector = ".js-steps-loop-scrollbar";

  if ($(sliderSelector).length === 0) {
    return;
  }

  const slider = new Swiper(sliderSelector, {
    slidesPerView: "auto",
    modules: [Pagination],
    centeredSlides: false,
    spaceBetween: 24,
    mousewheel: {
      forceToAxis: true,
    },
    pagination: {
      el: scrollbarSelector,
      type: 'progressbar'
    },
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 36,
      },
    },
  });
}

setTimeout(stepsLoopSlider, 0);
setTimeout(ourGalleryBottomSlider, 0);
